export const ENUM__html_ref_stub = {
  BUTTON: create_and_append_tag('button'),
  DIV: create_and_append_tag('div'),
  SPAN: create_and_append_tag('span'),
  INPUT: create_and_append_tag('input'),
  IMAGE: create_and_append_tag('img'),
  TEXT_AREA: create_and_append_tag('textarea'),
  CANVAS: create_and_append_tag('canvas'),
};

function create_and_append_tag<K extends keyof HTMLElementTagNameMap>(tag: K): HTMLElementTagNameMap[K] {
  const out = document.createElement(tag);
  const wrapper = document.createElement('div');
  wrapper.style.display = 'none';
  out.style.display = 'none';
  out.id = `${tag}_stub`;

  wrapper.appendChild(out);
  document.body.appendChild(wrapper); // optional: only if needed for style computation, etc.

  return out;
}
